import { Controller } from "@hotwired/stimulus"

// SPT-13 — a field whose text is over the maintained maximum wears the mark and
// carries the sentence that says so. The server renders both (SlotContent#overlong?),
// so a page without JavaScript still names the field; this only keeps the mark
// honest while somebody types, and takes it off the moment the text fits.
//
// The counter beside it ("12 / 40 Zeichen") is the one place the maximum is
// said, so it follows every keystroke.
export default class extends Controller {
  static targets = ["field", "note", "count"]
  static values = { max: Number }
  static classes = ["overlong"]

  check() {
    if (this.maxValue <= 0) return

    const length = this.textLength()
    if (this.hasCountTarget) this.countTarget.textContent = length
    this.mark(length > this.maxValue)
  }

  mark(overlong) {
    if (overlong) {
      this.fieldTarget.classList.add(...this.overlongClasses)
    } else {
      this.fieldTarget.classList.remove(...this.overlongClasses)
    }
    this.noteTarget.classList.toggle("d-none", !overlong)
  }

  // What the server counts is the plain text (SlotContent#to_s), so the rich
  // editor is asked for its document rather than for the markup around it.
  textLength() {
    const field = this.fieldTarget
    if (field.editor) return field.editor.getDocument().toString().replace(/\n+$/, "").length

    return field.value.length
  }
}
